import template from './sw-cms-preview-text-hero.html.twig';
import './sw-cms-preview-text-hero.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
